import { render, staticRenderFns } from "./TcHome.vue?vue&type=template&id=4ac6b1c4&"
import script from "./TcHome.vue?vue&type=script&lang=js&"
export * from "./TcHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac6b1c4')) {
      api.createRecord('4ac6b1c4', component.options)
    } else {
      api.reload('4ac6b1c4', component.options)
    }
    module.hot.accept("./TcHome.vue?vue&type=template&id=4ac6b1c4&", function () {
      api.rerender('4ac6b1c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcHome.vue"
export default component.exports